
import React from 'react';
import isUndefined from 'lodash/isUndefined';

import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { withRouter, RouteComponentProps, Link } from 'react-router-dom';
import { Modal } from 'antd';

import {
  getReviewBook,
  getHotelDetails,
  setExpiredSession,
  setLoadingBook,
  IReviewBookState,
  setReviewBook,
  setErrorBooking,
  resetState,
  IHotelDetailsState,
  IRoomsSearchState,
} from '@store/slices';
import { IBookingSummary } from '@common-types';
import { IAccount, ISessionKey } from '@share/common-types';
import {
  UrlUtils,
  getTimeout,
  getSessionObj,
  getHotelRoutePath,
  getHotelIdFromPath,
  getPackageIdFromPath,
  RootState,
  mergeHotelCertificateRouteHint,
  ICertificateRouteHint,
  isDisplayCertificates,
  runStripeExpressResumeFromQuery,
  mergeStripeExpressResumeSearch,
  computeCreditLineChargeTotal,
  isCreditLineCheckoutAccount,
  redirectToCheckoutFromStripeResume,
  consumeStripeResumeErrorFromLocation,
} from '@share/utils';
import { store } from '@store';
import { CreditLineCheckoutPageBanner, StripeResumeError } from '@share/components';
import { IInsuranceState, InsuranceSelection } from '@store/slices';
import { SESSION_KEY_LABEL_ROOMS, SESSION_KEY_LABEL, QUOTE_LABEL, LIFE_STYLE_NAME_PARAM, DETAIL_TYPE_PARAM_LABEL, DETAIL_TYPE_STATIC, CROSS_SELL_AT_CHECKOUT } from '@share/constants';
import { HOTEL_SESSION_KEY, NULL_VALUE, ROOMS_UNAVAILABLE_ERROR } from '@constants';
import { SkeletonReviewBook, PriceChangeMessage, GeneralMessage, MessageType, CrossSellSection } from '@components';
import { IFiltersState, IHotelsState, ILoginState, IMenuState } from '@share/store/slices';

import { ReviewBook } from '../review-book/review-book';
import { RoomInfo } from '../room-info';
import { RoomImage } from '../room-info/room-image';
import { Notification } from '../notification';
import { AvailabilityError } from '../notification/availability-error';

import './style.scss';

interface IMapStateToProps {
  hotelsStore: IHotelsState;
  reviewBookStore: IReviewBookState;
  hotelDetailsStore: IHotelDetailsState;
  roomsSearchStore: IRoomsSearchState;
  menuStore: IMenuState;
  loginStore: ILoginState;
  filtersStore: IFiltersState;
  insuranceStore: IInsuranceState;
}

interface IMapDispatchToProps {
  getReviewBook: (
    hotelId: number,
    packageId: string,
    sessionKey: ISessionKey | undefined,
    lifeType: string | null,
    quote: string | null,
    certificateRoute?: ICertificateRouteHint,
  ) => void;
  setExpiredSession: (expiredSession: boolean) => void;
  setLoadingBook: (loadingBook: boolean) => void;
  setReviewBook: (data: IBookingSummary) => void;
  setErrorBooking: (message: string) => void;
  resetState: () => void;
  getHotelDetails: (hotelId: number, sessionKey: ISessionKey, dealId?: number, quote?: string) => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, RouteComponentProps {
  isVacationRentals: boolean;
  isStripe?: boolean;
}

interface IState {
  expirationTimeout: number;
  detailType: string | null;
  stripeResumeError: string | null;
  stripeNoResume: boolean;
}

const ZERO = 0;
const MODAL_WIDTH = 400;

class ReviewBookWrapperComponent extends React.Component<IProps, IState> {
  state: IState = {
    expirationTimeout: NULL_VALUE,
    detailType: null,
    stripeResumeError: null,
    stripeNoResume: false,
  };

  hotelId = getHotelIdFromPath(this.props.history);
  packageId = getPackageIdFromPath(this.props.history);

  onExpiredSession = (sessionData: ISessionKey) => {
    const expireDate = sessionData.expireDate;

    if (getTimeout(expireDate) < ZERO) {
      this.props.setExpiredSession(true);
    } else {
      this.setState({
        // @ts-ignore
        expirationTimeout: setTimeout(() => {
          this.props.setExpiredSession(true);
        }, getTimeout(expireDate)),
      });
    }
  };

  componentDidMount(): void {
    const { menuStore } = this.props;
    const { items } = menuStore;

    const values = UrlUtils.getValues();
    const sessionKey = getSessionObj(
      values[SESSION_KEY_LABEL_ROOMS] as ISessionKey,
      values[SESSION_KEY_LABEL] as ISessionKey,
    );

    if (!isUndefined(sessionKey)) {
      localStorage.setItem(HOTEL_SESSION_KEY, JSON.stringify(sessionKey));
    }

    if (values[DETAIL_TYPE_PARAM_LABEL]) {
      this.setState({ detailType: (values[DETAIL_TYPE_PARAM_LABEL] as string) });
    }

    const sessionStorage = localStorage.getItem(HOTEL_SESSION_KEY);
    const currentSessionKey = !isUndefined(sessionKey)
      ? sessionKey
      : sessionStorage ? JSON.parse(sessionStorage) : null;

    if (this.props.isStripe) {
      const resumeSearch = mergeStripeExpressResumeSearch(
        this.props.history.location.search,
        currentSessionKey,
      );
      void runStripeExpressResumeFromQuery({
        dispatch: store.dispatch,
        getState: store.getState as () => RootState,
        history: this.props.history,
        pathname: this.props.history.location.pathname,
        search: resumeSearch,
        vertical: 'hotel',
      }).then((res) => {
        if (res.error && res.isResumeError) {
          // Resume call itself failed → hand off to the regular checkout page (which has the full
          // booking context) and let it surface the error inline as a normal checkout error.
          redirectToCheckoutFromStripeResume(this.props.history, res.error);
        } else if (res.error) {
          // Pre-resume failure (e.g., missing session) — show the full-page StripeResumeError.
          this.setState({ stripeResumeError: res.error });
        } else if (!res.ran) {
          // No bookingId in the URL (e.g., F5 after a successful booking, once params were stripped).
          this.setState({ stripeNoResume: true });
        }
      });
    } else {
      // Surface a resume error redirected here from the /stripe/hotel/... page (if any) so the
      // existing GeneralMessage banner picks it up.
      const stripeResumeErrorMsg = consumeStripeResumeErrorFromLocation(this.props.history);
      if (stripeResumeErrorMsg) {
        this.props.setErrorBooking(stripeResumeErrorMsg);
      }
      if (items) {
        this.getBookingSummary();
      }
    }

    this.onExpiredSession(currentSessionKey);
    
    window.scrollTo(ZERO, ZERO);
  }

  componentDidUpdate(prevProps: Readonly<IProps>): void {
    const { loginStore, menuStore, reviewBookStore } = this.props;
    const { account, user, userWalletData } = loginStore;
    const { items } = menuStore;
    const { loading, bookingSummary } = reviewBookStore;

    const userLoaded = !prevProps.loginStore.user && !!user;
    const walletLoaded = !prevProps.loginStore.userWalletData && !!userWalletData && account?.hasClientCash;
    const menuLoaded = !prevProps.menuStore.items && !!items && !loading && !bookingSummary;

    if (!this.props.isStripe && (userLoaded || walletLoaded || menuLoaded)) {
      this.getBookingSummary();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.state.expirationTimeout);
    this.props.resetState();
  }

  getCertificateRouteHint = (): ICertificateRouteHint | undefined => {
    return mergeHotelCertificateRouteHint(this.props.history.location.state, this.props.filtersStore);
  };

  getCertificateIdFromState = (): string | undefined => {
    return this.getCertificateRouteHint()?.certificateId;
  };

  getSessionId = () => {
    const values = UrlUtils.getValues();
    const sessionKey = getSessionObj(
      values[SESSION_KEY_LABEL_ROOMS] as ISessionKey,
      values[SESSION_KEY_LABEL] as ISessionKey,
    );

    const sessionStorage = localStorage.getItem(HOTEL_SESSION_KEY);
    const currentSessionKey = !isUndefined(sessionKey)
      ? sessionKey
      : sessionStorage ? JSON.parse(sessionStorage) : null;

    return currentSessionKey;
  }

  getBookingSummary = () => {
    if (this.props.isStripe) {
      return;
    }
    const { loginStore } = this.props;
    const { user, account } = loginStore;

    if (!!user && !!account) {
      const values = UrlUtils.getValues();
      const sessionKey = getSessionObj(
        values[SESSION_KEY_LABEL_ROOMS] as ISessionKey,
        values[SESSION_KEY_LABEL] as ISessionKey,
      );
  
      const sessionStorage = localStorage.getItem(HOTEL_SESSION_KEY);
      const currentSessionKey = !isUndefined(sessionKey)
        ? sessionKey
        : sessionStorage ? JSON.parse(sessionStorage) : null;

      const { roomsSearchStore, hotelDetailsStore } = this.props;
      const hotel = roomsSearchStore.hotel ? roomsSearchStore.hotel : hotelDetailsStore.hotel;
      if (!hotel) {
        this.props.getHotelDetails(this.hotelId, currentSessionKey);
      }

      let quote;
      if (values[QUOTE_LABEL]) {
        quote = (values[QUOTE_LABEL] as string);
      }

      let lifeType = 'none';
      if (UrlUtils.getSearchParam(LIFE_STYLE_NAME_PARAM)) {
        lifeType = UrlUtils.getSearchParam(LIFE_STYLE_NAME_PARAM) as string;
      }

      this.props.setLoadingBook(true);
      this.props.setReviewBook(NULL_VALUE);
      this.props.getReviewBook(
        this.hotelId,
        this.packageId,
        currentSessionKey,
        lifeType,
        quote as string,
        this.getCertificateRouteHint(),
      );
    }
  }

  render(): React.ReactNode {
    if (this.props.isStripe && this.state.stripeResumeError) {
      return (
        <div className="review-book-wrapper">
          <StripeResumeError />
        </div>
      );
    }

    if (this.props.isStripe && this.state.stripeNoResume) {
      return (
        <div className="review-book-wrapper">
          <StripeResumeError mode="go-to-search" />
        </div>
      );
    }

    const { isVacationRentals, reviewBookStore, insuranceStore, loginStore } = this.props;
    const {
      loading,
      bookingSummary,
      expiredSession,
      errorBooking,
      bookingComplete,
      isExternalError,
      isPriceChangedError,
      isSoldOutError,
      isBookingInProgress,
      isSavingsMismatch,
      error,
      selectedHotelReviewClientCash,
      rewardId,
    } = reviewBookStore;
    const { account } = loginStore;
    const { detailType } = this.state;
    const loadingLogin = loginStore.loading;
    const displayCertificates = isDisplayCertificates(account as IAccount);
    const { selection, insurance } = insuranceStore;
    
    const isNotification =
      bookingComplete ||
      isPriceChangedError ||
      isSoldOutError ||
      isBookingInProgress ||
      loading;

    const isRoomUnavaliableError = error === ROOMS_UNAVAILABLE_ERROR;
    const certificateId = this.getCertificateIdFromState();
    const certificateContextId =
      displayCertificates && certificateId?.trim() ? certificateId.trim() : '';

    const values = UrlUtils.getValues();
    const sessionKey = getSessionObj(
      values[SESSION_KEY_LABEL_ROOMS] as ISessionKey,
      values[SESSION_KEY_LABEL] as ISessionKey,
    );
    const sessionStorage = localStorage.getItem(HOTEL_SESSION_KEY);
    const currentSessionKey = !isUndefined(sessionKey)
      ? sessionKey
      : sessionStorage ? JSON.parse(sessionStorage) : null;

    const hotelPath = getHotelRoutePath(this.hotelId, this.props.history, isVacationRentals, currentSessionKey, detailType === DETAIL_TYPE_STATIC, bookingSummary?.bookingCard?.name);

    const { balance } = bookingSummary?.bookingCard ?? {};
    const { maxRewardWalletAmount } = bookingSummary?.bookingCard?.package ?? {};
    const convertionRate = loginStore.userWalletData?.convertionRate ?? 1;
    const insuranceAmount =
      selection === InsuranceSelection.YES && insurance?.productDetails?.price
        ? insurance.productDetails.price
        : 0;
    const rewardDeduction =
      rewardId && maxRewardWalletAmount && !bookingComplete ? maxRewardWalletAmount : 0;
    const creditLineBookingAmount =
      balance != null
        ? computeCreditLineChargeTotal({
            payOrBalance: balance,
            clientCashPoints: selectedHotelReviewClientCash,
            conversionRate: convertionRate,
            insuranceAmount,
            rewardDeduction,
          })
        : 0;
    const showCreditLineBanner =
      isCreditLineCheckoutAccount(loginStore.account) &&
      !isNotification &&
      !!bookingSummary &&
      !loading &&
      !loadingLogin;

    /** On stripe-return pages, the wrapper has no detail/booking data yet, so render a skeleton until
     * the resume settles (success → BookingConfirmed; failure → early-returned `<StripeResumeError />`). */
    const showStripeSkeleton = !!this.props.isStripe && !bookingComplete;

    return ((expiredSession || isExternalError) && !isRoomUnavaliableError) ? (
      <Notification
        expiredSession={expiredSession}
        isSavingsMismatch={isSavingsMismatch}
        isExternalError={isExternalError}
        isVacationRentals={isVacationRentals}
        errorCode={error}
      />
    ) : (
        <div className={`review-book-wrapper${bookingComplete ? ' review-book-wrapper--complete' : ''}`}>
        {!isNotification && !this.props.isStripe && (
          <div className="review-book-wrapper__header">
            <div className="review-book-wrapper__back-link">
              <Link to={hotelPath}>
                <FormattedMessage id="back.to.all.rooms" />
              </Link>
            </div>
            <h4 className="review-book-wrapper__title secondary-font">
              <FormattedMessage id="review.book" />
            </h4>
            <p className="review-book-wrapper__description">
              <FormattedMessage id="enter.your.details" />
            </p>
          </div>
        )}

        {showCreditLineBanner ? (
          <CreditLineCheckoutPageBanner
            bookingAmount={creditLineBookingAmount}
            currency={bookingSummary?.bookingCard?.package?.currency}
          />
        ) : null}

        {(loading || loadingLogin || showStripeSkeleton) && <SkeletonReviewBook />}

        {/* Suppress the inline error banner on /stripe/hotel/... — any resume failure that landed
            here is on its way to being redirected to the regular checkout page where the same
            banner will render. Showing it here causes a brief flash before the redirect.
            Also hide while *any* loading is in flight: the user shouldn't see an error layered on
            top of the skeleton on the checkout page (e.g. while getBookingSummary is fetching after
            a resume-failure redirect). */}
        {!this.props.isStripe &&
          !loading &&
          !loadingLogin &&
          !bookingComplete &&
          !isEmpty(errorBooking) && (
            <GeneralMessage type={MessageType.Failure} message={errorBooking}></GeneralMessage>
          )}

        {!certificateContextId && <PriceChangeMessage />}
        <div id="toast-container" style={{ position: 'absolute', top: 0, zIndex: 10000 }} />

        {/* On stripe-return pages we only render the inner ReviewBook once the booking confirmed
            successfully — otherwise the form (and any inline error inside it) would briefly flash
            before the resume-failure redirect navigates away (force-full-stripe flows can leave a
            `bookingSummary` in the store even when the resume call errored out). */}
        {(this.props.isStripe ? bookingComplete : !!bookingSummary) && !loading && (
          <div
            className={`review-book-wrapper__content ${
              isNotification ? 'wrapper-notification' : ''
            }`}
          >
            <ReviewBook isVacationRentals={isVacationRentals} certificateId={certificateContextId} />
            <div className="review-book-wrapper__right">
              <RoomImage />
              <RoomInfo certificateId={certificateContextId} />
            </div>
          </div>
        )}

        {/* The section belongs on the confirmation page. `CROSS_SELL_AT_CHECKOUT` also renders
            it before completion so it can be exercised without paying; off in every env. */}
        {(bookingComplete || (CROSS_SELL_AT_CHECKOUT && !!bookingSummary)) && (
          <CrossSellSection
            origin="hotel"
            propertyId={this.hotelId}
            checkIn={bookingSummary?.bookingCard?.checkIn}
            checkOut={bookingSummary?.bookingCard?.checkOut}
            currency={bookingSummary?.bookingCard?.package?.currency}
          />
        )}

        <Modal
          className="price-change-modal-wrapper"
          wrapClassName="price-change-modal-wrapper__wrap"
          visible={isRoomUnavaliableError && isExternalError}
          footer={null}
          title={null}
          closable={false}
          keyboard={false}
          destroyOnClose={true}
          width={MODAL_WIDTH}
        >
          <AvailabilityError isVacationRentals={isVacationRentals} />
        </Modal>
        </div>
    );
  }
}


const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    menuStore: state.navigationMenuStore,
    hotelsStore: state.hotelsStore,
    reviewBookStore: state.reviewBookStore,
    loginStore: state.loginStore,
    hotelDetailsStore: state.hotelDetailsStore,
    roomsSearchStore: state.roomsSearchStore,
    filtersStore: state.filtersStore,
    insuranceStore: state.insuranceStore,
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  getReviewBook,
  getHotelDetails,
  setExpiredSession,
  setLoadingBook,
  setReviewBook,
  setErrorBooking,
  resetState,
};

export const ReviewBookWrapper = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(ReviewBookWrapperComponent));
